import type { Account } from "../api/types";

/**
 * A "paper" account has no broker session — it exists only to home monitor-only
 * sleeves (e.g. the Crypto Carry ghost sleeves) so their forward paper P&L
 * renders on a drift card. `broker === "virtual"` is the signal: real trading
 * accounts are `"rithmic"`. Paper accounts never connect, never hold a broker
 * balance, and can never place an order, so the desk drops the broker-centric
 * chrome (connection state, balance, kill switch, broker positions, live toggle)
 * for them and reads cleanly as a forward-validation monitor.
 */
export const isPaperAccount = (a: Account): boolean => a.broker === "virtual";
